<div class="input-group input-group-sm">
  <input 
    type="text" 
    class="form-control form-control-sm text-truncate" 
    [placeholder]="effectivePlaceholder" 
    [value]="displayValue"
    [readonly]="isJsonOrList || readonly"
    [disabled]="disabled"
    (click)="onInputClick()"
    (blur)="onTouched()"
    (input)="onInputChange($event)"
    [style.cursor]="isJsonOrList ? 'pointer' : 'text'"
    [title]="displayValue">
  <button 
    *ngIf="isJsonOrList && !disabled && !readonly"
    class="btn btn-outline-secondary btn-sm px-2 py-1" 
    type="button"
    (click)="openEditor()">
    <i class="ph-pencil-simple" style="font-size: 12px;"></i>
  </button>
</div>


<div class="modal fade" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ getModalTitle() }}</h5>
        <button type="button"
                class="btn-close"
                (click)="closeModal()">
        </button>
      </div>
     
      <div>
      <div class="mb-3">

        <div class="d-flex align-items-center mb-2">
          <label class="form-label mb-0">
          {{ normalizedDataType === 'json' ? 'Enter JSON of ' + variableName : 'Enter List value of ' + variableName }}
          </label>

          <button
            *ngIf="normalizedDataType === 'json'"
            type="button"
            class="btn btn-outline-warning btn-sm ms-auto"
            (click)="beautifyJson()">
            Beautify JSON
          </button>
        </div>
          <textarea 
            class="form-control font-monospace" 
            [(ngModel)]="modalValue"
            [rows]="normalizedDataType === 'json' ? 12 : 6"
            [placeholder]="getModalPlaceholder()"
            (input)="validateInput()">
          </textarea>
          <div *ngIf="modalError" class="text-danger mt-2">
            <small><i class="ph-warning-circle me-1"></i>{{ modalError }}</small>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveValue()" [disabled]="!!modalError">
          <i class="ph-check me-1"></i>Save
        </button>
      </div>
    </div>
  </div>
</div>


<div class="modal-backdrop fade" [class.show]="showModal" *ngIf="showModal"></div>